var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemovedFlyerCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 544,
    viewBox: "0 0 390 544",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 544,
    fill: "#F7F7F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48.9375,
    y: 42.9714,
    width: 291.25,
    height: 17.9047,
    rx: 5.96825,
    fill: "#D4D7DF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35.8047,
    y: 93.9109,
    width: 316,
    height: 10,
    rx: 5,
    fill: "#E7E9ED"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 52.3047,
    y: 113.911,
    width: 283,
    height: 10,
    rx: 5,
    fill: "#E7E9ED"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 73.8047,
    y: 133.911,
    width: 240,
    height: 10,
    rx: 5,
    fill: "#E7E9ED"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 35.8047,
    y: 153.911,
    width: 316,
    height: 10,
    rx: 5,
    fill: "#E7E9ED"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 200,
    width: 292,
    height: 168,
    rx: 5.96825,
    fill: "#E7E9ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.223 400.018C236.644 398.948 225.338 444.827 184.992 449.475C166.87 451.556 159.877 439.777 139.015 444.729C119.121 449.453 104.575 465.12 95.168 478.145H310.417C291.216 400.391 273.81 400.588 261.223 400.018Z",
    fill: "#E7E9ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.001 481.076H230.551C231.411 479.629 232.742 478.539 234.311 477.999C236.604 477.176 238.717 477.553 240.883 477.622C246.749 477.806 248.576 475.583 255.366 474.137C257.167 473.726 259.004 473.509 260.848 473.491C261.292 473.491 262.157 473.491 266.992 473.868C270.902 474.183 270.887 474.229 271.504 474.198C272.903 474.145 275.805 474.014 278.219 472.291C281.475 469.983 281.791 466.198 284.521 464.752C285.416 464.299 286.36 463.955 287.333 463.728C287.913 463.607 288.502 463.532 289.093 463.505C293.928 463.274 298.869 466.39 300.373 469.129C300.634 469.708 301.002 470.23 301.456 470.667C302.472 471.537 303.648 472.188 304.915 472.583C307.809 473.63 310.781 474.433 313.803 474.983C318.341 475.824 322.562 477.933 326.001 481.076Z",
    fill: "#D4D7DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.825 484.983L64 484.66C65.1336 482.143 67.1874 480.131 69.7586 479.018C76.1035 476.444 82.1854 481.284 87.6433 478.776C92.3043 476.628 89.8309 472.156 94.3115 469.457C100.326 465.78 107.385 472.149 119.473 470.685C131.562 469.222 133.321 461.668 141.606 462.595C149.89 463.522 149.123 473.362 160.701 476.569C164.775 477.694 166.895 477.099 172.218 479.018C176.075 480.401 179.662 482.419 182.825 484.983Z",
    fill: "#D4D7DF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.78637,
    cy: 5.11843,
    rx: 1.78637,
    ry: 5.11843,
    transform: "matrix(0.98988 -0.14191 0.140931 0.990019 142.045 480.534)",
    fill: "#E7E9EE"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.42601,
    cy: 4.13542,
    rx: 1.42601,
    ry: 4.13542,
    transform: "matrix(0.791246 -0.611498 0.608792 0.79333 137.271 474.994)",
    fill: "#E7E9EE"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.43176,
    cy: 4.11769,
    rx: 1.43176,
    ry: 4.11769,
    transform: "matrix(0.946131 -0.323783 0.321742 0.946828 142.629 467.578)",
    fill: "#E7E9EE"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.53699,
    cy: 1.07759,
    rx: 3.53699,
    ry: 1.07759,
    transform: "matrix(0.466486 -0.884529 0.883163 0.469067 142.709 480.047)",
    fill: "#E7E9EE"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.09783,
    cy: 0.975743,
    rx: 2.09783,
    ry: 0.975743,
    transform: "matrix(0.786739 -0.617286 0.614587 0.788849 144.285 482.24)",
    fill: "#E7E9EE"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.974127,
    cy: 2.07886,
    rx: 0.974127,
    ry: 2.07886,
    transform: "matrix(0.973319 -0.229457 0.227927 0.973678 142.396 474.292)",
    fill: "#E7E9EE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M196.175 497.141V475.819H202.317C203.381 475.815 204.244 474.984 204.252 473.954V462.076C204.248 461.043 203.384 460.208 202.317 460.204H202.076C201.008 460.208 200.144 461.043 200.14 462.076V470.699C200.14 471.002 200.015 471.293 199.794 471.507C199.572 471.721 199.272 471.842 198.958 471.842H196.175V460.158C196.175 458.763 195.006 457.632 193.563 457.632V457.632C192.87 457.63 192.204 457.896 191.714 458.37C191.223 458.844 190.949 459.488 190.951 460.158V478.277H189.093C188.436 478.277 187.904 477.762 187.904 477.127V465.384C187.923 464.416 187.233 463.569 186.255 463.361C185.652 463.244 185.026 463.395 184.55 463.772C184.074 464.149 183.798 464.713 183.799 465.308V480.262V480.262C183.799 481.358 184.718 482.247 185.851 482.247H190.951V497.141C190.951 497.44 191.202 497.682 191.511 497.682H195.615C195.764 497.682 195.906 497.625 196.011 497.523C196.116 497.422 196.175 497.284 196.175 497.141V497.141Z",
    fill: "#B6BAC9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.394 491.239V479.134H258.479C258.821 479.134 259.149 478.988 259.391 478.728C259.633 478.468 259.768 478.115 259.768 477.748V468.967C259.768 468.6 259.632 468.248 259.39 467.989C259.148 467.73 258.82 467.586 258.479 467.588H258.318C257.61 467.588 257.036 468.205 257.036 468.967V475.343C257.036 475.814 256.681 476.195 256.244 476.195H254.394V464.497C254.417 463.511 253.747 462.664 252.839 462.53C252.347 462.466 251.854 462.63 251.482 462.981C251.11 463.332 250.895 463.837 250.891 464.369V471.092H249.65C249.441 471.092 249.24 471.002 249.093 470.842C248.946 470.682 248.864 470.466 248.866 470.241V466.585C248.877 465.85 248.395 465.214 247.723 465.078C247.329 465.02 246.93 465.145 246.626 465.423C246.322 465.7 246.143 466.104 246.133 466.532V472.562V472.562C246.133 473.38 246.739 474.049 247.499 474.069H250.891V491.277C250.891 491.577 251.116 491.819 251.395 491.819H253.855C254.001 491.831 254.144 491.773 254.248 491.662C254.351 491.551 254.405 491.396 254.394 491.239V491.239Z",
    fill: "#B6BAC9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M258.471 489.157C258.084 489.513 257.765 489.937 257.531 490.409C257.443 490.623 257.392 490.829 257.276 490.844C257.159 490.859 256.889 490.402 256.744 489.99C256.405 489.04 255.857 488.181 255.14 487.478C254.451 486.795 253.721 486.156 252.954 485.564C253.435 485.64 253.901 485.789 254.339 486.005C253.867 485.457 253.454 484.859 253.107 484.223C253.041 484.069 252.844 483.87 253.027 483.73C253.209 483.59 253.391 483.818 253.515 483.958C253.694 484.136 253.84 484.346 253.945 484.577C254.477 486.05 255.629 487.088 256.532 488.48C255.798 485.772 254.615 483.21 253.034 480.902C253.799 481.145 254.994 482.736 255.636 484.334C256.19 485.711 256.467 487.176 257.013 488.568C256.591 486.425 256.161 484.289 255.738 482.146C256.919 483.973 257.072 486.064 257.305 488.134C257.457 485.456 257.408 482.77 257.159 480.099C257.652 481.223 257.919 482.435 257.946 483.663C258.318 482.856 258.778 482.093 259.316 481.388C259.331 482.037 259.159 482.677 258.821 483.229C258.391 484.007 258.085 484.85 257.917 485.726C257.728 486.16 257.997 486.572 257.975 486.992C257.975 487.589 257.786 488.178 257.735 488.723C257.801 487.901 257.965 487.09 258.223 486.307C258.376 485.939 258.442 485.505 258.865 485.306C259.17 484.841 259.547 484.429 259.98 484.083C259.259 485.531 258.683 487.049 258.26 488.612C259.163 486.359 260.147 484.194 262.691 483.325C260.344 485.32 259.521 486.617 259.236 487.456C259.099 488.07 258.838 488.649 258.471 489.157V489.157Z",
    fill: "#B6BAC9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M204.471 495.019C204.206 494.922 203.952 494.795 203.714 494.641C203.306 494.379 203.087 494.093 202.663 493.807C202.438 493.657 202.2 493.528 201.952 493.422C201.051 492.969 200.051 492.757 199.048 492.804C198.117 492.881 198.291 493.159 197.187 493.244C196.431 493.306 196.007 493.182 195.47 493.483C195.084 493.707 195.19 493.831 194.676 494.255C194.156 494.583 193.616 494.874 193.057 495.127C192.708 495.275 192.382 495.476 192.089 495.721C191.662 496.275 191.499 496.993 191.643 497.682H206.604C206.856 497.592 207.057 497.395 207.156 497.141C207.208 496.875 207.156 496.598 207.012 496.37C206.885 496.073 206.693 495.809 206.452 495.598C205.923 495.189 205.545 495.436 204.471 495.019Z",
    fill: "#DFE1E8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemovedFlyerCard);
export default __webpack_public_path__ + "static/media/removed_flyer_card.ea4f420f5773310c2275133e6852e480.svg";
export { ForwardRef as ReactComponent };